import { PublishingInfoForm } from "./PublishingInfoForm";

export default PublishingInfoForm;
